import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { nurseNeedsDAL } from '../dal/nurse-needs.dal';

@Injectable({
  providedIn: 'root',
})
export class nurseNeedsService {
  constructor(private nurseNeedsDAL: nurseNeedsDAL) {}

  generateNeeds(TVOCycleId: string, startDate: string, endDate: string): Observable<any[]> {
    return this.nurseNeedsDAL.generateNeeds(TVOCycleId, startDate, endDate);
  }

  getNurseFixNeeds(tvo: string, period: string, week?: number): Observable<any[]> {
    return this.nurseNeedsDAL.getNurseFixNeeds(tvo, period, week);
  }

  updateNurseFixNeeds(tvo: string, needs: any[], period: string, week?: number): Observable<any[]> {
    return this.nurseNeedsDAL.updateNurseFixNeeds(tvo, needs, period, week);
  }

  getNurseDailyNeeds(weekDay: string, period: string): Observable<any[]> {
    return this.nurseNeedsDAL.getNurseDailyNeeds(weekDay, period);
  }

  updateNurseDailyNeeds(weekDay: string, needs: any[]): Observable<any[]> {
    return this.nurseNeedsDAL.updateNurseDailyNeeds(weekDay, needs);
  }

  generateNurseDailyNeeds(
    tvoId: string,
    fromDate: string,
    toDate: string,
    creationType: string,
    startingWeekNumber?: number
  ): Observable<any[]> {
    return this.nurseNeedsDAL.generateNurseDailyNeeds(tvoId, fromDate, toDate, creationType, startingWeekNumber);
  }
}
